import { Switch, Route } from 'react-router';

import NewOutlets from './new-outlets/table';
import UpdatesOutlets from './update-outlets/table';
import Outlets from './outlets/table';
import OutletsGrid from './outlets/grid';
import CreateOutlet from './outlets/create';
import EditOutlet from './outlets/edit';
import UpdateOutlet from './outlets/update';
import RoutesTable from './routes/table';
import HistoryTable from './history/table';
import { OutletsUpdateImport } from './import/outlets-update';
import { OutletsCreateImport } from './import/outlets-create';
import { SalesSourceOutletsImport } from './import/sales-source-outlets';
import { OutletRouteNumberLinkCreateImport } from './import/outlet-route-number-link-create';
import { OutletRouteNumberLinkDeleteImport } from './import/outlet-route-number-link-delete';
import { OutletRoutesImport } from './import/outlet-routes';
import { CreateNewOutlet } from './new-outlets/create';
import { CreateUpdateOutlet } from './update-outlets/create';
import SubChannelsTable from './sub-channels/table';
import { ViewUpdateOutlet } from './update-outlets/view';
import { UpdateRequestDetail } from './update-outlets/request-detail';
import ViewCreateOutlet from './new-outlets/view';

export const CustomerListDomain = () => {
  return (
    <Switch>
      <Route exact path="/acl/new-outlets/" component={NewOutlets} />
      <Route exact path="/acl/new-outlets/create" component={CreateNewOutlet} /> 
      <Route exact path="/acl/new-outlets/:id/view" component={ViewCreateOutlet} /> 
      <Route exact path="/acl/updates-outlets/" component={UpdatesOutlets} />
      <Route exact path="/acl/outlet-approvals/" render={() => <UpdatesOutlets approvalQueue />} />
      <Route exact path="/acl/updates-outlets/request/:id" component={UpdateRequestDetail} />
      <Route exact path="/acl/updates-outlets/create" component={CreateUpdateOutlet} />
      <Route exact path="/acl/updates-outlets/:id/view" component={ViewUpdateOutlet} />
      <Route exact path="/acl/outlets/create" component={CreateOutlet} />
      <Route exact path="/acl/outlets/:id/update" component={UpdateOutlet} />
      <Route exact path="/acl/outlets/grid/" component={OutletsGrid} />
      <Route exact path="/acl/outlets/:id/" component={EditOutlet} />
      <Route exact path="/acl/outlets/" component={Outlets} />
      <Route exact path="/acl/routes/" component={RoutesTable} />
      <Route exact path="/acl/history/" component={HistoryTable} />
      <Route exact path="/acl/import/outlets-update/" component={OutletsUpdateImport} />
      <Route exact path="/acl/import/outlets-create/" component={OutletsCreateImport} />
      <Route exact path="/acl/import/sales-source-outlets/" component={SalesSourceOutletsImport} />
      <Route exact path="/acl/import/outlet-route-number-link-create/" component={OutletRouteNumberLinkCreateImport} />
      <Route exact path="/acl/import/outlet-route-number-link-delete/" component={OutletRouteNumberLinkDeleteImport} />
      <Route exact path="/acl/import/outlet-routes/" component={OutletRoutesImport} />
      <Route exact path="/acl/sub-channels/" component={SubChannelsTable} />
    </Switch>
  );
};
